{
  "success": {
    "analyses/setMovable": "Analisi aggiornata",
    "analyses/moveIntoPlan": "Analisi spostata con successo nel piano",
    "analyses/remove": "Analisi rimossa dal piano con successo",
    "analysisDefinitions/create": "Aggiunta nuova definizione di analisi",
    "analysisDefinitions/edit": "Modificata definizione di analisi",
    "analysisDefinitions/remove": "Eliminata definizione di analisi",
    "analysisDraft/create": "Aggiunta nuova bozza di analisi",
    "analysisDraft/edit": "Modificata bozza di analisi",
    "samples/delete-unlocked": "Eliminati tutti i campioni non pianificati",
    "assets/remove": "Strumento eliminato con successo",
    "assets/create": "Aggiunto nuovo strumento",
    "assets/edit": "Strumento modificato",
    "competenceGroups/create": "Gruppo di competenza creato",
    "competenceGroups/edit": "Gruppo di competenza modificato con successo",
    "competenceGroups/remove": "Gruppo di competenza eliminato con successo",
    "iap/run": "IAP eseguito con successo",
    "iap/runFillInSamples": "Campioni compilati con successo",
    "integrationSheets/createActionSheet": "Foglio aggiunto",
    "integrationSheets/createProjectTemplateSheets": "Foglio aggiunto",
    "integrationSheets/createSampleSheet": "Foglio aggiunto",
    "integrationSheets/editActionSheet": "Foglio modificato",
    "integrationSheets/editProjectTemplateSheet": "Foglio modificato",
    "integrationSheets/editSampleSheet": "Foglio modificato",
    "integrationSheets/removeActionSheet": "Foglio eliminato",
    "integrationSheets/removeProjectTemplateSheet": "Foglio eliminato",
    "integrationSheets/removeSampleSheet": "Foglio eliminato",
    "integrationSheets/saveSapConversionSheet": "Foglio Importazione Progetto salvato",
    "members/create": "Membro aggiunto",
    "members/createAsAdmin": "Membro aggiunto",
    "members/edit": "Membro modificato",
    "members/archive": "Membro archiviato",
    "projectActions/editPlanned": "Azione di progetto modificata",
    "projectActions/move": "Azione di progetto inserita nel programma",
    "projectActions/setMovable": "Azione di progetto aggiornata",
    "projectActions/setLocation": "Posizione aggiornata",
    "projectActions/setLocationUnplanned": "Posizione aggiornata",
    "projectActions/editUnplanned": "Azione di progetto non pianificata modificata",
    "projectActions/removePlanned": "Progetto non pianificato",
    "projects/create": "Progetto creato",
    "projects/edit": "Progetto aggiornato",
    "projects/remove": "Progetto eliminato",
    "projects/delete-unplanned": "Eliminati tutti i progetti non pianificati",
    "projects/lockProject": "Progetto bloccato",
    "projects/unlockProject": "Progetto sbloccato",
    "projectTemplates/create": "Nuovo modello di progetto creato",
    "projectTemplates/createDraft": "Nuova bozza di modello di progetto creata",
    "projectTemplates/edit": "Modello di progetto modificato",
    "projectTemplates/editDraft": "Bozza di modello di progetto modificata",
    "projectTemplates/remove": "Modello di progetto eliminato",
    "whiteTasks/remove": "Attività eliminata con successo",
    "whiteTasks/create": "Attività creata",
    "whiteTasks/edit": "Attività modificata con successo",
    "whiteTasks/createRecurrence": "Ricorrenza creata",
    "whiteTasks/removeRecurrence": "Attività ricorrenti rimosse",
    "teamStatus/start": "Accesso alla Modalità Simulazione",
    "teamStatus/accept": "Cambiamenti Modalità Simulazione applicati",
    "teamStatus/discard": "Cambiamenti Modalità Simulazione scartati",
    "customers/addCustomer": "Cliente aggiunto",
    "customers/editCustomer": "Cliente modificato",
    "customers/deleteCustomer": "Cliente eliminato",
    "team/create-api-token": "Token API creato",
    "team/delete-api-token": "Token API eliminato"
  },
  "error": {
    "analyses/remove/ERROR": "Rimozione dell'analisi dal piano non riuscita",
    "analysisDefinitions/create/ERROR": "Aggiunta nuova definizione di analisi non riuscita",
    "analysisDefinitions/remove/ERROR": "Eliminazione definizione di analisi non riuscita",
    "assets/remove/ERROR": "Eliminazione strumento non riuscita",
    "assets/create/ERROR": "Aggiunta strumento non riuscita",
    "auth/login/ERROR": "Accesso non riuscito",
    "competenceGroups/create/ERROR": "Creazione del gruppo di competenza non riuscita",
    "competenceGroups/remove/ERROR": "Eliminazione gruppo di competenza non riuscita",
    "iap/run/ERROR": "Esecuzione IAP non riuscita",
    "iap/runFillInSamples/ERROR": "Compilazione campioni non riuscita",
    "integrationSheets/createActionSheet/ERROR": "Aggiunta foglio non riuscita",
    "integrationSheets/createProjectTemplateSheets/ERROR": "Aggiunta foglio non riuscita",
    "integrationSheets/createSampleSheet/ERROR": "Aggiunta foglio non riuscita",
    "integrationSheets/editActionSheet/ERROR": "Modifica foglio non riuscita",
    "integrationSheets/editProjectTemplateSheet/ERROR": "Modifica foglio non riuscita",
    "integrationSheets/editSampleSheet/ERROR": "Modifica foglio non riuscita",
    "integrationSheets/removeActionSheet/ERROR": "Si è verificato un errore durante il tentativo di eliminare il foglio",
    "integrationSheets/removeProjectTemplateSheet/ERROR": "Si è verificato un errore durante il tentativo di eliminare il foglio",
    "integrationSheets/removeSampleSheet/ERROR": "Si è verificato un errore durante il tentativo di eliminare il foglio",
    "loading/fetchAll/ERROR": "Caricamento non riuscito",
    "members/create/ERROR": "Aggiunta membro non riuscita",
    "members/createAsAdmin/ERROR": "Aggiunta membro non riuscita",
    "members/archive/ERROR": "Archiviazione membro non riuscita",
    "projectActions/move/ERROR": "Pianificazione dell'azione non riuscita",
    "projectActions/removePlanned/ERROR": "Rimozione dell'azione dal piano non riuscita",
    "projectActions/setLocation/ERROR": "Aggiornamento posizione non riuscito",
    "projectActions/setLocationUnplanned/ERROR": "Aggiornamento posizione non riuscito",
    "projects/create/ERROR": "Aggiunta nuovo progetto non riuscita",
    "projects/remove/ERROR": "Eliminazione progetto non riuscita",
    "projects/delete-unplanned/ERROR": "Eliminazione progetti non pianificati non riuscita",
    "projects/lockProject/ERROR": "Blocco azioni non riuscito",
    "projectTemplates/create/ERROR": "Creazione nuovo modello di progetto non riuscita",
    "projectTemplates/createDraft/ERROR": "Creazione nuova bozza di modello di progetto non riuscita",
    "projectTemplates/remove/ERROR": "Eliminazione modello di progetto non riuscita",
    "whiteTasks/remove/ERROR": "Eliminazione attività non riuscita",
    "whiteTasks/create/ERROR": "Creazione dell'attività non riuscita",
    "teamStatus/start/ERROR": "Accesso alla Modalità Simulazione non riuscito",
    "teamStatus/accept/ERROR": "Applicazione cambiamenti Modalità Simulazione non riuscita",
    "teamStatus/discard/ERROR": "Scarto cambiamenti Modalità Simulazione non riuscito",
    "customers/deleteCustomer/ERROR": "Impossibile eliminare il cliente",
    "customers/addCustomer/ERROR": "Impossibile aggiungere il cliente",
    "customers/editCustomer/ERROR": "Impossibile modificare il cliente",
    "team/create-api-token/ERROR": "Impossibile creare il token API",
    "team/delete-api-token/ERROR": "Impossibile eliminare il token API"
  },
  "adhoc": {
    "welcomeBack": "Benvenuto!",
    "noSoundDetected": "Nessun suono rilevato. Si prega di riprovare.",
    "noMicrophoneDetected": "Nessun microfono rilevato. Si prega di riprovare.",
    "iapRunning": "Un momento - IAP del tuo team è in esecuzione",
    "failedDiscardNotLoggedOut": "Scarto dei cambiamenti non riuscito. Non sei stato disconnesso!",
    "cannotDragRecurrentTask": "Non è possibile trascinare un'attività ricorrente",
    "cannotMoveImportedTasks": "Non è possibile spostare le attività importate",
    "noCheckboxesSelected": "Nessuna casella di controllo selezionata",
    "analysisUpdatedRefresh": "Analisi aggiornata, si prega di aggiornare",
    "analysisUpdatedByAnotherUser": "L'analisi è stata aggiornata da un altro utente, si prega di aggiornare",
    "copiedToClipboard": "Copiato negli appunti",
    "couldNotCopyToClipboard": "Impossibile copiare negli appunti",
    "chooseFirstAction": "Si prega di scegliere il primo {{itemType}}",
    "chooseSecondAction": "Si prega di scegliere il secondo {{itemType}}",
    "chooseTwoDifferent": "Si prega di scegliere due {{itemType}} diversi",
    "constraintConflicts": "Quel vincolo è in conflitto con quelli esistenti",
    "sampleCreated": "Campione creato",
    "sampleDeleted": "Campione eliminato",
    "samplesUpdated": "Campioni aggiornati",
    "sampleMarkedDone": "Campione contrassegnato come completato",
    "memberPermissionsChanged": "Autorizzazioni membro modificate",
    "chooseUniqueName": "Scegli un nome univoco",
    "fillRequiredFields": "Completa i campi obbligatori",
    "couldNotDetermineSampleIdDone": "Impossibile determinare l'ID del campione da contrassegnare come completato",
    "couldNotDetermineSampleIdDelete": "Impossibile determinare l'ID del campione da eliminare",
    "couldNotDetermineSampleIdDeleteMissing": "Impossibile determinare l'ID del campione da eliminare — dati mancanti. Controllare la console per i dettagli.",
    "anErrorOccurred": "Si è Verificato un Errore",
    "selectFileBeforeSubmitting": "Si prega di selezionare almeno un file prima dell'invio",
    "helpPageUpdated": "Pagina di aiuto aggiornata",
    "processingStarted": "Elaborazione avviata",
    "failedLoadingIcalFiles": "Caricamento file iCalendar non riuscito",
    "unsortBeforePasting": "Disattiva l'ordinamento della tabella prima di incollare più celle.",
    "fillAllRequiredFields": "Completa tutti i campi obbligatori",
    "unsavedChangesConfirmLeave": "Hai cambiamenti non salvati. Per confermare che desideri uscire, premi il pulsante indietro di nuovo.",
    "provideSheetName": "Si prega di fornire un Nome Foglio",
    "sheetNameAlreadyExists": "Il foglio con quel nome esiste già",
    "provideSheetType": "Si prega di fornire un Tipo di Foglio",
    "didNotSpellDeleteProperly": "Non hai digitato DELETE correttamente",
    "domainMustStartWithAt": "Il dominio deve iniziare con '@'",
    "fillOutRequiredFields": "Si prega di compilare i campi richiesti",
    "selectValidDates": "Seleziona date valide",
    "noIapModeSelected": "Nessuna modalità IAP selezionata. Si prega di selezionare una modalità.",
    "oneCollaboratorForWorkday": "È possibile selezionare solo un collaboratore per l'intera giornata lavorativa",
    "fillRequiredDateTimeFields": "Completa tutti i campi di data e ora obbligatori",
    "endMustBeAfterStart": "La fine dell'attività deve essere dopo l'inizio",
    "recurrencesCannotExceed365": "Il numero di ricorrenze non può essere superiore a 365",
    "pleaseFillNumberAndInterval": "Si prega di compilare il numero e l'intervallo di ricorrenze",
    "pleaseFillNumberOfRecurrences": "Si prega di compilare il numero di ricorrenze",
    "pleaseFillIntervalOfRecurrences": "Si prega di compilare l'intervallo di ricorrenze",
    "pleaseFillAllPeriodFields": "Si prega di compilare tutti i campi del periodo",
    "pleaseSelectReportType": "Si prega di selezionare almeno un tipo di report",
    "reportEmptyInInterval": "Il {{fileName}} è vuoto nell'intervallo specificato",
    "promptTooLong": "Prompt troppo lungo (max 1200 caratteri)",
    "nameTooLong": "Nome troppo lungo (max 100 caratteri)"
  }
}
